import { Market } from '../../api/markets.types';

export type MarketsActions = SetMarketsFetchingAction | SetMarketsAction;

export interface SetMarketsFetchingAction {
  type: 'MARKETS_SET_IS_FETCHING';
  data: boolean;
}
export function setMarketsFetching(value: boolean): SetMarketsFetchingAction {
  return {
    type: 'MARKETS_SET_IS_FETCHING',
    data: value,
  };
}

export interface SetMarketsAction {
  type: 'MARKETS_SET_MARKETS';
  data: Market[];
}
export function setMarkets(value: Market[]): SetMarketsAction {
  return {
    type: 'MARKETS_SET_MARKETS',
    data: value,
  };
}
